"use stric";

const FilterCarsItems = {
  brands: {
    name: "brands",
    title: "Брэнды",
  },
  groups: {
    name: "groups",
    title: "Группы",
  },
  winterCompanies: {
    name: "winterCompanies",
    title: "Компании",
  },
  types: {
    name: "types",
    title: "Типы",
  },
  inMove: {
    name: "inMove",
    title: "В движении",
  },
  noData: {
    name: "noData",
    title: "Нет данных",
  },
  withInActive: {
    name: "withInActive",
    title: "Показать неактивные ТС",
  },
  parking: {
    name: "parking",
    title: "Стоянка",
  },
  fueling: {
    name: "fueling",
    title: "Заправка",
  },
  drain: {
    name: "drain",
    title: "Слив топлива",
  },
  gpsJammng: {
    name: "gpsJammng",
    title: "Глушение GPS",
  },
  speedingPoints: {
    name: "speedingPoints",
    title: "Привышение скорости",
  },
  sensorFuel: {
    name: "sensorFuel",
    title: "Датчик уровня топлива",
  },
  sensorFlowMeter: {
    name: "sensorFlowMeter",
    title: "Расходомер",
  },
  sensorEquipment: {
    name: "sensorEquipment",
    title: "Дополнительное оборудование",
  },
  sensorSand: {
    name: "sensorSand",
    title: "Датчик посыпка песка и соли",
  },
  sensorDump: {
    name: "sensorDump",
    title: "Датчик отвала",
  },
  sensorVideo: {
    name: "sensorVideo",
    title: "Видеокамера",
  },
  sensorTemperature: {
    name: "sensorTemperature",
    title: "Температура",
  },
  sensorDistance: {
    name: "sensorDistance",
    title: "Датчик пробега",
  },
};

export default FilterCarsItems;
